// (B) 명령형 Modal(confirm/info/warning/error) 백엔드 — radix DialogStack 위임(antd 미사용, D4-2).
// React hook / 비React 싱글톤 동일(DialogStack store 는 realm 별 모듈 전역 — App 컨텍스트·bridge 불필요).
import type { OmwConfirmApi } from '../modal/useConfirm'
import { openConfirm } from './DialogStack'

export const omwConfirm: OmwConfirmApi = {
  confirm: (opts) => openConfirm('confirm', opts),
  info: (opts) => openConfirm('info', opts),
  warning: (opts) => openConfirm('warning', opts),
  error: (opts) => openConfirm('error', opts),
}

export function useModalImpl(): OmwConfirmApi {
  return omwConfirm
}
